import React from 'react';

import { Variant } from '../../types/IThemeColors';

interface BadgeProps {
  variant?: Variant;
  children?: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = (props) => {
  const variant = props.variant ?? 'primary';

  return <span className={`m-1 px-2 py-1 rounded-lg text-${variant}-text bg-${variant} hover:bg-${variant}-dark shadow-md shadow-hover`}>{props.children}</span>;
}

export default Badge;